import { font, query, space } from '@design/templateFns';
import { ThemeSpacingName } from '@design/theme';
import { ThemeFontName } from '@design/types';
import styled from 'styled-components';

export const Headline = styled.h1<{
  $font?: ThemeFontName;
  $mobileFont?: ThemeFontName;
  $m?: string;
  $p?: string;
  $color?: string;
}>`
  ${({ $font }) => ($font ? font($font) : font('headline-sm'))};
  ${({ $m }) => ($m ? `margin: ${$m};` : `margin: 0 0 20px;`)}
  ${({ $p }) => ($p ? `padding: ${$p};` : `padding: 0;`)}
  ${({ $color }) => ($color ? `color: ${$color};` : ``)}
  @media screen and (${query.below('tablet')}) {
    ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : ``)};
  }
`;

export const Text = styled.p<{
  $font?: ThemeFontName;
  $mobileFont?: ThemeFontName;
  $m?: string;
  $p?: string;
  $color?: string;
}>`
  ${({ $font }) => ($font ? font($font) : font('body-md-light'))};
  ${({ $m }) => ($m ? `margin: ${$m};` : ``)}
  ${({ $p }) => ($p ? `padding: ${$p};` : ``)}
  ${({ $color }) => ($color ? `color: ${$color};` : ``)}
  @media screen and (${query.below('tablet')}) {
    ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : ``)};
  }
`;

export const List = styled.div<{
  $gap?: ThemeSpacingName;
  $p?: ThemeSpacingName;
  $bg?: string;
  $center?: boolean;
  $centerHorz?: boolean;
  $centerVert?: boolean;
  $mobileP?: ThemeSpacingName;
}>`
  display: grid;
  grid-gap: ${({ $gap }) => ($gap ? space($gap) : '0px')};
  padding: ${({ $p }) => ($p ? space($p) : '0px')};
  background-color: ${({ $bg }) => ($bg ? $bg : 'transparent')};
  ${({ $center }) =>
    $center
      ? `
    justify-items: center;
    align-content: center;
  `
      : ``}
  ${({ $centerHorz }) =>
    $centerHorz
      ? `
    justify-content: center;
  `
      : ``}
  ${({ $centerVert }) =>
    $centerVert
      ? `
    align-content: center;
  `
      : ``}
  @media screen and (${query.below('tablet')}) {
    padding: ${({ $mobileP }) => ($mobileP ? space($mobileP) : ``)};
    grid-gap: 0;
  }
`;

export const ListCol = styled.div<{
  $gap?: ThemeSpacingName;
  $p?: ThemeSpacingName;
  $bg?: string;
  $center?: boolean;
  $centerHorz?: boolean;
  $centerVert?: boolean;
}>`
  display: grid;
  grid-auto-flow: column;
  grid-gap: ${({ $gap }) => ($gap ? space($gap) : '0px')};
  padding: ${({ $p }) => ($p ? space($p) : '0px')};
  background-color: ${({ $bg }) => ($bg ? $bg : 'transparent')};
  justify-content: start;
  ${({ $center }) =>
    $center
      ? `
    justify-items: center;
    align-content: center;
  `
      : ``}
  ${({ $centerHorz }) =>
    $centerHorz
      ? `
    justify-content: center;
  `
      : ``}
  ${({ $centerVert }) =>
    $centerVert
      ? `
    align-items: center;
  `
      : ``}
`;

export const ListColAlt = styled.div<{
  $gap?: ThemeSpacingName;
  $p?: ThemeSpacingName;
}>`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: start;
  grid-gap: ${({ $gap }) => ($gap ? space($gap) : '0px')};
  padding: ${({ $p }) => ($p ? space($p) : '0px')};
  @media screen and (${query.below('tablet')}) {
    grid-auto-flow: row;
  }
`;
